import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
    header: {
        height: 95,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 90
    },

    headerMobile: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 10
    },

    circle: {
        height: 63,
        width: 63,
        backgroundColor: '#FFC646',
        borderRadius: 63,
    },

    title: {
        fontSize: 24,
        color: '#535353',
        fontFamily: 'Montserrat',
        marginLeft: 8
    },

    menuItem: {
        fontSize: 18,
        color: '#535353',
        fontFamily: 'Montserrat',
        marginLeft: 36,
    },

    menuHorizontal: {
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
        justifyContent: 'flex-end'
    },

    menuVertical: {
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        width: '100%',
        overflow: 'hidden',
        backgroundColor: 'rgb(255, 198, 70)',
        top: 60,
        right: 0,
    },

    beebondsContainer: {
        display: 'flex',
        padding: 25,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },

    beebondsLogoImage: {
        height: 63,
        width: 63,
        borderRadius: 63
    },

    mobileMenuContainer: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        maxWidth: '100%'
    }

});